import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { MatDialog } from '@angular/material/dialog';
import { RunSheetDialogComponent } from '../dialogs/run-sheet-dialog/run-sheet.dialog';

@Injectable({
  providedIn: 'root'
})
export class RunSheetService {


    constructor(private http: HttpClient,
        private connectionService: ConnectionService,
        public dialog: MatDialog) {}


    openRunSheetDialog(runSheet: any, callback: any) {
        let dialog = this.dialog.open(RunSheetDialogComponent, {
            autoFocus: false,
            height: '100vh',
            width: '80vw',
            maxHeight: '99%',
            maxWidth: '80vw',
            data: {
                runSheet
            }
        });
    
        dialog.afterClosed().subscribe(data => {
            if (typeof callback === 'function') {
                callback(data);
            }
        })
    }

    getDefault() {
        return this.http.post(this.connectionService.address + "/run-sheet-service/get-default", {});
    }

    updateDefault(runSheet: any) {
        return this.http.post(this.connectionService.address + "/run-sheet-service/update-default", { runSheet });
    }

}
